import { thirdPartyLogisticsTypes } from '../store/slices/thirdPartyLogisticsSlice';

export const getThirdPartyLogistics = (payload) => ({
  type: thirdPartyLogisticsTypes.CREATE_THIRD_PARTY_LOGISTICS,
  payload,
});
